import type { FC } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { useHeaderContext } from '../../hooks/use-header-context/use-header-context';
import { EntityInfoContainer } from '../entity-info/entity-info-container';
import { HeaderActions } from '../header-actions/header-actions';
import { SocialProof } from '../social-proof/social-proof';

import * as Styled from './secondary-area.styles';

export const SecondaryArea: FC = () => {
  const { isLoggedOut } = useLoginState();
  const { isSubpage } = usePageContext();
  const { hasTertiaryArea } = useHeaderContext();

  return (
    <Styled.SecondaryArea>
      {!isSubpage ? (
        <div>
          <EntityInfoContainer />
        </div>
      ) : null}
      {isSubpage && !isLoggedOut ? (
        <div>
          <SocialProof />
        </div>
      ) : null}
      {!hasTertiaryArea ? (
        <Styled.HeaderActionsArea>
          <HeaderActions />
        </Styled.HeaderActionsArea>
      ) : null}
    </Styled.SecondaryArea>
  );
};
